var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"icon-tooltip"},[_c('Icon',{staticClass:"icon-tooltip-icon",attrs:{"name":_vm.iconName,"size":_vm.iconSize}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }